
import React, { useState } from 'react';
import './AssetsPage.css';
import PageHeader from '../../components/shared/PageHeader';
import Button from '../../components/shared/Button';
import Badge from '../../components/shared/Badge';
import { useToast } from '../../context/ToastContext';

type AssetType = 'All' | 'Images' | 'Documents' | 'Exports' | 'Generated';

const ASSETS = [
  { id: 1, name: 'Q1 Revenue Report.pdf', type: 'Documents', size: '2.4 MB', date: 'Feb 23, 2026', icon: '📄', badge: 'PDF' },
  { id: 2, name: 'Dashboard Mockup v3', type: 'Images', size: '1.1 MB', date: 'Feb 21, 2026', icon: '🖼', badge: 'PNG' },
  { id: 3, name: 'AI Generated Logo Set', type: 'Generated', size: '4.8 MB', date: 'Feb 20, 2026', icon: '✨', badge: 'ZIP' },
  { id: 4, name: 'CRM Data Export', type: 'Exports', size: '890 KB', date: 'Feb 18, 2026', icon: '📊', badge: 'CSV' },
  { id: 5, name: 'Brand Color Palette', type: 'Images', size: '340 KB', date: 'Feb 17, 2026', icon: '🎨', badge: 'SVG' },
  { id: 6, name: 'Flowchart Diagram', type: 'Exports', size: '680 KB', date: 'Feb 15, 2026', icon: '📐', badge: 'PNG' },
  { id: 7, name: 'AI Chat Export', type: 'Generated', size: '128 KB', date: 'Feb 14, 2026', icon: '🤖', badge: 'JSON' },
  { id: 8, name: 'Invoice Template', type: 'Documents', size: '520 KB', date: 'Feb 12, 2026', icon: '💳', badge: 'PDF' },
];

export default function AssetsPage() {
  const [filter, setFilter] = useState<AssetType>('All');
  const [view, setView] = useState<'grid' | 'list'>('grid');
  const { addToast } = useToast();

  const filtered = filter === 'All' ? ASSETS : ASSETS.filter(a => a.type === filter);

  return (
    <div className="assets-page">
      <PageHeader
        title="Assets"
        breadcrumb={['Studio', 'Assets']}
        actions={
          <>
            <div className="view-toggle">
              <button className={`view-toggle__btn${view === 'grid' ? ' view-toggle__btn--active' : ''}`} onClick={() => setView('grid')}>⊞</button>
              <button className={`view-toggle__btn${view === 'list' ? ' view-toggle__btn--active' : ''}`} onClick={() => setView('list')}>☰</button>
            </div>
            <Button icon="+" size="sm" onClick={() => addToast('info', 'Upload dialog coming soon!')}>Upload</Button>
          </>
        }
      />

      <div className="assets-filters">
        {(['All', 'Images', 'Documents', 'Exports', 'Generated'] as AssetType[]).map(f => (
          <button
            key={f}
            className={`assets-filter${filter === f ? ' assets-filter--active' : ''}`}
            onClick={() => setFilter(f)}
          >
            {f}
            <span className="assets-filter__count">
              {f === 'All' ? ASSETS.length : ASSETS.filter(a => a.type === f).length}
            </span>
          </button>
        ))}
      </div>

      {view === 'grid' ? (
        <div className="assets-grid">
          {filtered.map(a => (
            <div key={a.id} className="asset-card" onClick={() => addToast('info', `Opening: ${a.name}`)}>
              <div className="asset-card__thumb">
                <span className="asset-card__icon">{a.icon}</span>
                <span className="asset-card__badge">{a.badge}</span>
              </div>
              <div className="asset-card__info">
                <div className="asset-card__name">{a.name}</div>
                <div className="asset-card__meta">{a.size} · {a.date}</div>
              </div>
              <div className="asset-card__actions">
                <button className="asset-btn" onClick={e => { e.stopPropagation(); addToast('success', 'Downloaded!'); }}>⬇</button>
                <button className="asset-btn" onClick={e => { e.stopPropagation(); addToast('info', 'Link copied!'); }}>🔗</button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="assets-list">
          {filtered.map(a => (
            <div key={a.id} className="asset-row">
              <span className="asset-row__icon">{a.icon}</span>
              <div className="asset-row__info">
                <span className="asset-row__name">{a.name}</span>
                <span className="asset-row__type">{a.type}</span>
              </div>
              <Badge variant="default">{a.badge}</Badge>
              <span className="asset-row__size">{a.size}</span>
              <span className="asset-row__date">{a.date}</span>
              <div className="asset-card__actions">
                <button className="asset-btn" onClick={() => addToast('success', 'Downloaded!')}>⬇</button>
                <button className="asset-btn" onClick={() => addToast('info', 'Link copied!')}>🔗</button>
                <button className="asset-btn asset-btn--danger">🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
